export default __webpack_public_path__ + "static/media/285.ae9b5bd3.jpg";